import {DynamicModalLoaderService} from "@ispm/layout/services/dynamic-modal-loader.service";
import {ModalManagementService} from "@ispm/layout/services/modal-management.service";
import {NotificationMessageService} from "@ispm/core/components/customise-notification/notifications-message.service";
import {MessageService} from "@wuitk/angular/components/notification";
import {IEService} from "@ispm/shared/services/IE.service";
import {UsersStoreHandler} from "@ispm/test/services/users-store-handler";
import {TestSummaryActionsService} from "@ispm/test/services/test-summary-actions.service";
import {UICustomizationService} from "@ispm/shared/services/ui-customization.service";
import {DashboardService} from "../../../worklist/services/dashboard.service";
import {
  AgregationService,
  BundleCall,
  FlattenService,
  WorkflowUtilService
} from "@ispm-client/modules/aggregator/services";
import {InterpolateService} from "@ispm/shared/services/interpolate.service";
import {SessionStorageService} from "@ispm/shared/services/session-storage.service";
import {StoreActionCreatorService} from "@ispm/shared/services/store-action-creator.service";
import {DiagnosticOrderActionsService} from "@ispm/test/services/diagnostic-order-actions.service";
import {WorkflowService} from "@ispm/workflow/services/workflow.service";
import {PollJobService} from "@ispm/test/services/poll-job.service";
import {WorkflowConfigService} from "@ispm/workflow/services/workflow-config.service";
import {TestService} from "@ispm/test/services/test.service";
import {ResourceRestService} from "@ispm/workflow/services/resource-rest.service";
import {FormHandlerService} from "@ispm/dynamic-form/services/form-handler.service";
import {NavigationConfigService} from "@ispm/navigation/services/navigationConfig.service";
import {AuthenticationService} from "@ispm/user/services/authentication.service";
import {UserActionCreatorService} from "@ispm/user/services/user-action-creator.service";
import {LoginComponent} from "@ispm/migration/components/login-component/component/login.component";
import {
  getCheckAuthLevel,
  getClinicalUsageLogin, getForgottenPasswordUrl,
  getVersion
} from "@ispm/migration/components/login-component/login.route.resolve";

export const LOGIN_COMPONENTS = [
  LoginComponent
];

export const LOGIN_SERVICES = [
  AuthenticationService,
  DynamicModalLoaderService,
  ModalManagementService,
  NotificationMessageService,
  MessageService,
  IEService,
  UsersStoreHandler,
  TestSummaryActionsService,
  UICustomizationService,
  DashboardService,
  AgregationService,
  BundleCall,
  InterpolateService,
  UserActionCreatorService,
  SessionStorageService,
  StoreActionCreatorService,
  FlattenService,
  WorkflowUtilService,
  DiagnosticOrderActionsService,
  WorkflowService,
  PollJobService,
  WorkflowConfigService,
  TestService,
  ResourceRestService,
  FormHandlerService,
  NavigationConfigService,
  getCheckAuthLevel,
  getClinicalUsageLogin,
  getVersion,
  getForgottenPasswordUrl
];
